module.exports = __webpack_public_path__ + "img/chr_ts_90_23_2.d6faad35.png";